// Which Positions the Contacts screen shows for a person. DISPLAY ONLY: nothing here creates, changes or reconciles an assignment.
//
// Canonical Position assignments are the authoritative source and are always shown. A roster record can also hold a Position that
// has no canonical assignment yet — for example a person whose identity is still provisional, so the governed assignment process
// has not been able to record it. That Position is real roster data and is shown too, marked as roster-only, instead of making
// the person look like they hold nothing. A roster Position that a canonical assignment already covers is never shown twice.
import type { DirectoryPerson } from '../types';

export interface DisplayedPosition {
  name: string;
  /** True when only the roster record holds it (no canonical assignment of that Position). */
  rosterOnly: boolean;
}

export function displayedPositions(person: Pick<DirectoryPerson, 'positions' | 'contactPositions'>): DisplayedPosition[] {
  const out: DisplayedPosition[] = [];
  const seen = new Set<string>();
  for (const name of person.positions) {
    if (typeof name !== 'string' || !name || seen.has(name)) continue;
    seen.add(name);
    out.push({ name, rosterOnly: false });
  }
  // An older server does not send the roster Positions; the list then shows the canonical ones, as it always did.
  for (const name of person.contactPositions ?? []) {
    if (typeof name !== 'string' || !name || seen.has(name)) continue;
    seen.add(name);
    out.push({ name, rosterOnly: true });
  }
  return out.sort((a, b) => a.name.localeCompare(b.name));
}

export const displayedPositionNames = (person: Pick<DirectoryPerson, 'positions' | 'contactPositions'>): string[] =>
  displayedPositions(person).map((p) => p.name);
